
























































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import TeacherMainteTab from "../../components/TeacherMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, UserResultViewableRange } from "../../modules/teacher/UserResultViewableRangeList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  user_result_viewable_ranges: UserResultViewableRange[]
  fields: any[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "teacher-mainte-tab": TeacherMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 2,
      condition: new SearchCondition(),
      user_result_viewable_ranges: new Array<UserResultViewableRange>(),
      fields: [
        {key: "user_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      isAllDeleteChecked: false,
      errors: [],
    });

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.user_result_viewable_ranges.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.user_result_viewable_ranges.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/user_result_viewable_range_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/teacher/user_result_viewable_range_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `成績閲覧マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/user_result_viewable_range_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.user_result_viewable_ranges = response.data.user_result_viewable_ranges.map((x: any) => new UserResultViewableRange(x)); 
        state.totalCount = state.user_result_viewable_ranges.length == 0 ? 0 : state.user_result_viewable_ranges[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      searchButtonClick,
      clearCondition,
      allSelectChanged,
      deleteMst,
      changePage,
      download,
    };
  }
});
